import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
import { useChallenge, useUnits } from '../../../hooks';
import { GeogroupAvatar } from '../../geogroup-avatar';
import { SponsorBadge } from '../../sponsor-badge';
import { medals } from '../medals';
function LeaderboardCompanyItem({
  blurred,
  ownGeogroup,
  challengeType,
  item,
  prevItemRank,
  enableParticipants,
  onOwnCompanyClick,
  onRowClick
}) {
  const {
    getProgressValueWithUnit
  } = useChallenge();
  const {
    formatNumber
  } = useUnits();
  const medal = item && medals[item.rank - 1] || null;
  const own = Boolean(item && ownGeogroup && ownGeogroup.id === item.id);
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1,
    onClick: onOwnCompanyClick && own ? onOwnCompanyClick : onRowClick && item?.id ? () => onRowClick(item.id) : undefined,
    paddingX: 2,
    paddingY: 1,
    sx: {
      justifyContent: 'flex-start',
      textAlign: 'left',
      textTransform: 'initial',
      color: 'initial',
      ...(own ? {
        bgcolor: '#F3F6FF'
      } : {}),
      ...(blurred ? {
        filter: 'blur(0.25rem)'
      } : {}),
      ...(onRowClick && item?.id ? {
        cursor: 'pointer',
        '&:hover': {
          bgcolor: '#f5f5f5'
        }
      } : {})
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexShrink: 0,
    height: 24,
    justifyContent: "center",
    width: 30
  }, !item ? /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 24
  }) : item.rank === prevItemRank ? /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, "-") : medal ? /*#__PURE__*/React.createElement("img", {
    src: medal.icon,
    width: 24
  }) : /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, Math.max(item.rank, item.leaderboardIndex))), /*#__PURE__*/React.createElement(GeogroupAvatar, {
    geogroup: item ? {
      title: item.parentTitle || item.title,
      photo: item.parentPhoto || item.photo
    } : undefined,
    size: 48
  }), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    variant: "body2"
  }, item ? /*#__PURE__*/React.createElement(React.Fragment, null, item.parentTitle ? `${item.parentTitle} - ` : '', item.title) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), item?.certified && /*#__PURE__*/React.createElement(SponsorBadge, {
    size: "small"
  })), enableParticipants && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: 100
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    align: "center",
    variant: "body2"
  }, item ? formatNumber(item.activeParticipantsCount) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "100%"
  }))), /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: 100
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    align: "center",
    variant: "body2"
  }, item ? !item.activeParticipantsCount || item.progressValue === 0 ? '-' : getProgressValueWithUnit(challengeType || 'bttf', item.progressValue / item.activeParticipantsCount) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "100%"
  })))), /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: 80
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    align: "right",
    variant: "body2"
  }, item ? item.progressValue === 0 ? '-' : getProgressValueWithUnit(challengeType || 'bttf', item.progressValue) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "100%"
  }))));
}
export default LeaderboardCompanyItem;